import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Anchored Lonely Fly</title>
        <meta property="og:title" content="Anchored Lonely Fly" />
        <link
          rel="canonical"
          href="https://anchored-lonely-fly-iksq9t.teleporthq.app/"
        />
        <meta
          property="og:url"
          content="https://anchored-lonely-fly-iksq9t.teleporthq.app/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-intro">
        <div className="hero-video-wrapper">
          <video
            autoPlay="true"
            muted="true"
            loop="true"
            playsInline="true"
            src="https://videos.pexels.com/video-files/9302772/9302772-hd_1280_720_30fps.mp4"
            className="hero-video"
          ></video>
          <div className="hero-scrim"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title">Elevated Living</h1>
          <p className="hero-subtitle">
            Experience the pinnacle of luxury vacation rentals with LuxeVista.
          </p>
          <a href="#reservations">
            <div className="btn btn-primary btn-lg">
              <span>Book Your Stay</span>
            </div>
          </a>
        </div>
      </section>
      <section className="quick-links">
        <div className="quick-links-container">
          <div className="quick-links-grid">
            <a href="#rooms">
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4m-8-6v6M2 18h20"
                    ></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Exquisite Rooms</h3>
                <p className="section-content">
                  Discover our curated selection of premium suites.
                </p>
              </div>
            </a>
            <a href="#gallery">
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <rect
                        width="18"
                        height="18"
                        x="3"
                        y="3"
                        rx="2"
                        ry="2"
                      ></rect>
                      <circle cx="9" cy="9" r="2"></circle>
                      <path d="m21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Visual Journey</h3>
                <p className="section-content">
                  Explore the breathtaking vistas of our properties.
                </p>
              </div>
            </a>
            <a href="#reservations">
              <div className="quick-link-card">
                <div className="quick-link-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M8 2v4m8-4v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Reservations</h3>
                <p className="section-content">
                  Secure your escape to unparalleled tranquility.
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="featured-properties">
        <div className="featured-header">
          <h2 className="section-title">Signature Residences</h2>
          <a href="#rooms">
            <div className="btn btn-link">
              <span>View All Rooms</span>
            </div>
          </a>
        </div>
        <div className="property-rail">
          <div className="property-card">
            <img
              src="https://images.pexels.com/photos/7902912/pexels-photo-7902912.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Azure Infinity Villa"
              className="property-img"
            />
            <div className="property-overlay">
              <h3 className="section-subtitle">Azure Infinity Villa</h3>
              <p className="section-content">
                Private pool with seamless Mediterranean views.
              </p>
            </div>
          </div>
          <div className="property-card">
            <img
              src="https://images.pexels.com/photos/10203485/pexels-photo-10203485.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Serene Cliff Retreat"
              className="property-img"
            />
            <div className="property-overlay">
              <h3 className="section-subtitle">Serene Cliff Retreat</h3>
              <p className="section-content">
                Architectural masterpiece perched above the sea.
              </p>
            </div>
          </div>
          <div className="property-card">
            <img
              src="https://images.pexels.com/photos/28000936/pexels-photo-28000936.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="The Whitewash Suite"
              className="property-img"
            />
            <div className="property-overlay">
              <h3 className="section-subtitle">The Whitewash Suite</h3>
              <p className="section-content">
                Minimalist elegance meets traditional charm.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="brand-statement">
        <div className="brand-container">
          <div className="brand-card">
            <h2 className="section-title">The LuxeVista Ethos</h2>
            <p className="section-content">
              At LuxeVista, we believe that luxury is found in the details and
              felt in the atmosphere. Our curated collection of vacation rentals
              is designed for those who seek more than just a place to stay;
              they seek an experience. Every property is selected for its
              exceptional design, prime location, and the unique serenity it
              offers to our guests.
            </p>
            <div className="brand-stats">
              <div className="stat-item">
                <span className="stat-value">12+</span>
                <span className="stat-label">Prime Locations</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">100%</span>
                <span className="stat-label">Guest Satisfaction</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">24/7</span>
                <span className="stat-label">Personal Concierge</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="gallery-preview">
        <div className="gallery-grid">
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/7902914/pexels-photo-7902914.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Poolside Relaxation"
            />
          </div>
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/34854573/pexels-photo-34854573.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Luxury Interior"
            />
          </div>
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/10611847/pexels-photo-10611847.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Sunset Balcony"
            />
          </div>
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/34874601/pexels-photo-34874601.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Aerial Infinity Pool"
            />
          </div>
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/32727436/pexels-photo-32727436.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Mykonos Sunset"
            />
          </div>
          <div className="gallery-item">
            <img
              src="https://images.pexels.com/photos/30195980/pexels-photo-30195980.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Palm-fringed Villa"
            />
          </div>
        </div>
      </section>
      <section className="testimonials">
        <div className="testimonials-container">
          <div id="testimonialCarousel" className="testimonial-carousel">
            <div className="testimonial-item active">
              <blockquote className="section-title">
                <span>
                  &quot;A sanctuary of peace. The attention to detail in the
                  design made our stay truly unforgettable.&quot;
                </span>
              </blockquote>
              <cite className="section-subtitle">— Elena R., London</cite>
            </div>
            <div className="testimonial-item">
              <blockquote className="section-title">
                <span>
                  &quot;Unmatched views and service. LuxeVista redefined what we
                  expect from a vacation rental.&quot;
                </span>
              </blockquote>
              <cite className="section-subtitle">— Marcus T., New York</cite>
            </div>
            <div className="testimonial-item">
              <blockquote className="section-title">
                <span>
                  &quot;Minimalism at its finest. The space felt both expansive
                  and incredibly intimate.&quot;
                </span>
              </blockquote>
              <cite className="section-subtitle">— Sophia L., Paris</cite>
            </div>
          </div>
          <div className="carousel-controls">
            <button
              data-index="0"
              aria-label="Slide 1"
              className="carousel-dot active"
            ></button>
            <button
              data-index="1"
              aria-label="Slide 2"
              className="carousel-dot"
            ></button>
            <button
              data-index="2"
              aria-label="Slide 3"
              className="carousel-dot"
            ></button>
          </div>
        </div>
      </section>
      <section className="quick-booker">
        <div className="booker-container">
          <div className="booker-card">
            <div className="booker-content">
              <h2 className="section-title">Begin Your Escape</h2>
              <p className="section-content">
                Select your preferred dates to see availability for our
                exclusive properties.
              </p>
            </div>
            <div className="booker-ui">
              <div className="date-picker-mock">
                <div className="date-input">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M8 2v4m8-4v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </g>
                  </svg>
                  <span>Check-In</span>
                </div>
                <div className="date-divider"></div>
                <div className="date-input">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M8 2v4m8-4v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </g>
                  </svg>
                  <span>Check-Out</span>
                </div>
              </div>
              <a href="#reservations">
                <div className="btn btn-primary btn-lg">
                  <span>Check Availability</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
        @keyframes heroFadeUp {to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="luxevista-logic">
(function(){
  const testimonials = document.querySelectorAll(".testimonial-item")
  const dots = document.querySelectorAll(".carousel-dot")
  let currentSlide = 0

  function showSlide(index) {
    testimonials.forEach((t) => t.classList.remove("active"))
    dots.forEach((d) => d.classList.remove("active"))

    testimonials[index].classList.add("active")
    dots[index].classList.add("active")
    currentSlide = index
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      showSlide(index)
    })
  })

  setInterval(() => {
    let next = (currentSlide + 1) % testimonials.length
    showSlide(next)
  }, 5000)

  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  document.querySelectorAll(".quick-link-card, .property-card, .brand-card").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(30px)"
    el.style.transition = "opacity 0.8s ease, transform 0.8s ease"
    observer.observe(el)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      
    </div>
  )
}

export default Home
